<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M3.90625 3.51562C3.90625 2.43694 4.78069 1.5625 5.85938 1.5625H9.375C11.5324 1.5625 13.2812 3.31139 13.2812 5.46875V7.42188C13.2812 8.50056 14.1557 9.375 15.2344 9.375H17.1875C19.3449 9.375 21.0938 11.1239 21.0938 13.2812V21.4844C21.0938 22.5631 20.2193 23.4375 19.1406 23.4375H5.85937C4.78069 23.4375 3.90625 22.5631 3.90625 21.4844V3.51562ZM8.59375 14.8438C8.16228 14.8438 7.8125 15.1935 7.8125 15.625C7.8125 16.0565 8.16228 16.4062 8.59375 16.4062H16.4062C16.8377 16.4062 17.1875 16.0565 17.1875 15.625C17.1875 15.1935 16.8377 14.8438 16.4062 14.8438H8.59375ZM7.8125 18.75C7.8125 18.3185 8.16228 17.9688 8.59375 17.9688H16.4062C16.8377 17.9688 17.1875 18.3185 17.1875 18.75C17.1875 19.1815 16.8377 19.5312 16.4062 19.5312H8.59375C8.16228 19.5312 7.8125 19.1815 7.8125 18.75ZM14.8438 5.46875C14.8438 4.10099 14.3416 2.8505 13.5117 1.89157C17.0522 2.81643 19.8398 5.60404 20.7647 9.14459C19.8058 8.31462 18.5553 7.8125 17.1875 7.8125H15.2344C15.0186 7.8125 14.8438 7.63761 14.8438 7.42188V5.46875ZM7.86875 9.90508C7.96275 10.3793 8.19231 10.8328 8.56895 11.2654C8.94181 11.6936 9.45985 12.1017 10.1348 12.4897C10.1573 12.5032 10.1854 12.5034 10.2081 12.4903C10.8834 12.1021 11.4018 11.694 11.7748 11.2654C12.1515 10.8328 12.381 10.3793 12.4749 9.90503C12.6017 9.29142 12.237 8.68305 11.636 8.50573C11.0351 8.32842 10.3985 8.64136 10.1719 9.22552C9.94563 8.64206 9.31032 8.32898 8.70979 8.50501C8.10926 8.68104 7.74349 9.28756 7.86802 9.90084C7.86823 9.90224 7.86875 9.90363 7.86875 9.90508Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgForYou',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>